export default "__VITE_ASSET__Br_ltiAH__"